import React, { useRef } from 'react'
import { motion } from 'framer-motion'

import ContentfulLongText from '../../ContentfulLongText'
import { InfoIcon } from '../../Icons'

export const CardItem = ({ item, index, contentVisibility, setContentVisibility }) => {
    const ref = useRef(null);
    return (
        <motion.div
            ref={ref}
            key={index}
            className={`relative item${contentVisibility === index ? ' active' : ''}`}
            onMouseEnter={() => setContentVisibility(index)}
            onMouseLeave={() => setContentVisibility(null)}
            >
            <h3 className="mt-0 mb-0 text-center">{item.title}</h3>
            <div className="relative image-info">
                <img
                src={item.image.gatsbyImageData.images.fallback.src}
                className="absolute top-0 right-0 bottom-0 left-0"
                alt={item.title || 'Info Media'}
                />
                <ContentfulLongText longTextContent={item.content.content} />
            </div>
            <button
                type="button"
                className="btn--plain"
                onMouseEnter={() => setContentVisibility(null)}
                onClick={() => setContentVisibility(index)}
            >
                <InfoIcon />
            </button>
        </motion.div>
    )
}